import { template, random } from 'lodash'

/**
 * Cache singleton.
 */
let cache = {}

/**
 * Получение lodash шаблона из разметки.
 * @param {string} templateName Селектор элемента с шаблоном
 * @returns {Function} Lodashed-шаблон
 */
export const getTemplate = templateName => {
  if (!cache[templateName] || process.env.NODE_ENV === 'test') {
    cache[templateName] = template(document.querySelector(templateName) ? document.querySelector(templateName).innerHTML : '')
  }
  return cache[templateName]
}

/**
 * Получение JSON из разметки.
 * @param {string} jsonName Селектор элемента с json данными
 * @returns {JSON} Полученный JSON
 */
export const getJson = jsonName => {
  let json = null
  try {
    json = JSON.parse(document.querySelector(jsonName) ? document.querySelector(jsonName).innerHTML : '')
  } catch (e) {
    return null
  }
  return json
}

/**
 * Если id=mask доступен, возвращает mask. В противном случае добавляем к mask случайное число и снова проверяем
 * @param {string} mask Идентификатор
 * @returns {*} mask|random Новый идентификатор
 */
export const generateUniqId = mask => {
  if (document.querySelectorAll(`#${mask}`).length === 0) {
    return mask
  } else {
    return generateUniqId(mask + '-' + random(1, 1000000, false))
  }
}
